// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  SET_BULK_EDIT_BAND_OPTIONS,
  SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS,
  SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS,
  SET_BULK_EDIT_MODAL, SET_BULK_EDIT_PATHS,
  SET_BULK_EDIT_VISIBLE_PATH_IDS,
  UPDATE_BULK_EDIT_STATE,
} from './types'

export const setBulkEditBandOptions = bulkEditBandOptions => ({
  type: SET_BULK_EDIT_BAND_OPTIONS,
  bulkEditBandOptions,
})

export const setBulkEditHighlightedPathIds = highlightedPathIds => ({
  type: SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS,
  highlightedPathIds,
})

export const setBulkEditHighlightedSiteIds = highlightedSiteIds => ({
  type: SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS,
  highlightedSiteIds,
})

export const setBulkEditPaths = bulkEditPaths => ({
  type: SET_BULK_EDIT_PATHS,
  bulkEditPaths,
})

export const setBulkEditVisiblePathIds = visiblePathIds => ({
  type: SET_BULK_EDIT_VISIBLE_PATH_IDS,
  visiblePathIds,
})

export const setBulkEditModal = (modalConfig = null) => ({
  type: SET_BULK_EDIT_MODAL,
  modalConfig,
})

// newState is an object which will be merged into the bulkEdit redux state.
export const updateBulkEditState = newState => ({
  type: UPDATE_BULK_EDIT_STATE,
  newState,
})
